import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M16 32C7.125 32 0 24.875 0 16C0 7.1875 7.125 0 16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32ZM14.5 16C14.5 16.5 14.75 17 15.125 17.25L21.125 21.25C21.8125 21.75 22.75 21.5625 23.1875 20.875C23.6875 20.1875 23.5 19.25 22.8125 18.75L17.5 15.25V7.5C17.5 6.6875 16.8125 6 15.9375 6C15.125 6 14.4375 6.6875 14.4375 7.5L14.5 16Z'],
  name: 'uiClockSolid',
  oldName: 'fasClock'
} as IconDefinition
